import PropTypes from 'prop-types'
import SpammableReviewActions from './spammable_review_actions'
import Button from '../Button'
import Popover from '../Popover'

const AdminBarSpammable = props => {
  const getReferenceContent = () => {
    const { spammableLocked } = props
    const html = spammableLocked ? 'Manage spam &#128274;' : 'Manage spam'
    return (
      <Button className="button-reset">
        <span dangerouslySetInnerHTML={{ __html: html }} />
      </Button>
    )
  }

  const getPopoverContent = () => {
    const { spammableId, spammableType } = props
    return (
      <div className="popover--opaque p">
        <SpammableReviewActions spammableId={spammableId} spammableType={spammableType} />
      </div>
    )
  }

  const reference = getReferenceContent()
  const popover = getPopoverContent()
  return (
    <Popover>
      <Popover.Reference className="top-bar__item">{reference}</Popover.Reference>
      <Popover.Content className="popover">{popover}</Popover.Content>
    </Popover>
  )
}

AdminBarSpammable.propTypes = {
  spammableId: PropTypes.number.isRequired,
  spammableType: PropTypes.string.isRequired,
}

export default AdminBarSpammable
